import { render, staticRenderFns } from "./RegistrationPaymentStep.vue?vue&type=template&id=76b42ff7&"
import script from "./RegistrationPaymentStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPaymentStep.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationPaymentStep.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports